import React, { ReactNode } from "react"
import Components from "../index"

import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"

import remarkReactComponents from "../../helpers/remarkReactComponents"

import { blokType } from "../../types"

import { StyledFooterContainer } from "./partials"

export interface FooterProps {
  footer_menu: blokType[]
  footer_cta: blokType[]
  legal: string
  copyright: string
  footer_social: blokType[]
  landingFooter: boolean
  legacy: boolean
}

export const FooterCmp: React.FC<FooterProps> = ({
  footer_menu,
  footer_cta,
  legal,
  copyright,
  footer_social,
  landingFooter,
  legacy
}) => (
  <footer className="footer" data-name="footer">
    <StyledFooterContainer legacy={legacy} className={legacy ? "container" : ""}>
      {!landingFooter && (
        <div className="footer__links">
          <nav className="footer__nav">
            {footer_menu &&
              footer_menu.map((content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
          </nav>
          <div className="footer__right">
            {footer_cta &&
              footer_cta.map((content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                  className: legacy ? "footer__btn footer__btn--desktop btn--alt" : "",
                })
              )}
            <div className="footer__social">
              {footer_social &&
                footer_social.map((content) =>
                  React.createElement(Components(content.component), {
                    key: content._uid,
                    blok: content,
                  })
                )}
            </div>
          </div>
        </div>
      )}
      <div className="footer__legal">
        {
          unified()
            .use(remarkParse)
            .use(remarkRehype)
            .use(rehypeReact as any, {
              createElement: React.createElement,
              components: remarkReactComponents,
              Fragment: React.Fragment
            })
            .processSync(legal).result as ReactNode
        }
      </div>
      <div className="footer__copyright">
        {
          unified()
            .use(remarkParse)
            .use(remarkRehype)
            .use(rehypeReact as any, {
              createElement: React.createElement,
              components: remarkReactComponents,
              Fragment: React.Fragment
            })
            .processSync(copyright).result as ReactNode
        }
      </div>
    </StyledFooterContainer>
  </footer>
)

export default FooterCmp
